import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { NgClass } from '@angular/common';
import { ReadReceiptComponent } from '../read-receipt/read-receipt.component';

@Component({
    selector: 'app-video',
    templateUrl: './video-chat-bubble.component.html',
    styleUrls: ['./video-chat-bubble.component.scss'],
    imports: [NgClass, ReadReceiptComponent]
})
export class VideoComponent implements OnInit, AfterViewInit {
  @Input() messageSource: Boolean;
  @Input() content: any;
  public previewVideoSrc: any;
  public videoModule: any;
  public previewCaption: any;

  @ViewChild('previewVideoModule', { static: true }) previewVideoModule: TemplateRef<any>;
  @ViewChild('divElement', { static: true }) divElement: ElementRef;
  @ViewChild('videoElement', { static: true }) videoElement: ElementRef;

  constructor(public sanitization: DomSanitizer, private dialog: MatDialog) {}

  ngOnInit() {
    this.previewCaption = this.content['description'];
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.imageSizeCalculation();
    }, 500);
  }

  previewImage(event) {
    this.previewVideoSrc = this.sanitization.bypassSecurityTrustUrl(event.srcElement.src);
    this.videoModule = this.dialog.open(this.previewVideoModule, {
      panelClass: 'previewVideo',
      width: '499px',
      height: '554px',
      disableClose: true,
    });
  }

  onClosePreview() {
    this.videoModule.close();
  }

  getVideoImage() {
    return this.sanitization.bypassSecurityTrustUrl(`${this.content['src']}#t=0.1`);
  }

  async imageSizeCalculation() {
    if (this.videoElement.nativeElement.videoWidth >= this.videoElement.nativeElement.videoHeight) {
      this.divElement.nativeElement.style.height = 'auto';
      this.divElement.nativeElement.style.maxWidth = '236px';
    } else {
      this.divElement.nativeElement.style.maxHeight = '226px';
      this.divElement.nativeElement.style.maxWidth = '175px';
    }
  }
}
